<template>
  <div>
    <!--    头部-->
    <NavTop :parentData="this.$route.params.tabBarId" class="navbar"></NavTop>
    <!-- banner -->
    <div class="banner" style="height: 300px;">
      <swiper class="swiper" :options="swiperOptions">
        <swiper-slide class="swiper_img" v-for="(slide, index) in slides" :key="index">
          <img style="height: 300px;" :src="slide.url" alt="Slide Image">
          <!--          @click.stop="clickRoute('/bannerDetail',slide.id)"-->
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <!-- 通知公告 -->
    <div class="menu6_box2">
      <div class="box2_list content">
        <div class="box1_r" v-for="(item,index) in childData" :key="index">
          <div class="t_title">
            <span>{{ item.childName }}</span>
            <span @click="clickGengDuo(item)">查看更多</span>
          </div>
          <div class="t_list">
            <ul class="t_list_ul">
              <li class="t_list_li time" v-for="(item1,index1) in item.articleList" :key="index1"
                  @click="clcikList(item1)">
                <span>{{ item1.title }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavTop from '../../components/comcomponents/NavTop.vue'
import home from '../../api/home'
import child from '../../api/child'

export default {
  components: {
    NavTop,
  },
  data () {
    return {
      // 轮播图数据
      swiperOptions: {
        pagination: {el: '.swiper-pagination', clickable: true},
        navigation: {nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev'},
        loop: true,
        autoplay: {
          delay: 10000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        speed: 10000
      },
      slides: [],
      // 数据
      childData: [],
    }
  },
  created () {
    this.getData(this.$route.params.tabBarId)
  },
  mounted () {
    this.getTu() // 获取轮播图
  },
  methods: {
    // 点击学校新闻产学研用列表
    clickRoute (path, id) {
      this.$router.push(path + '/' + id)
    },
    // 获取首页轮播图
    async getTu () {
      try {
        const res = await home.getBanner({bannerPath: '/party/common/office'})
        if (res.code === 200) {
          this.slides = res.rows.filter(item => item.tabBarId == 9)
        }
      } catch (e) {
        console.error(e)
      }
    },
    // 获取数据
    async getData (tabBarId) {
      try {
        const res = await child.getChild({tabBarId})
        this.childData = res.data
      } catch (e) {
        console.log(e)
      }
    },
    // 点击查看更多
    clickGengDuo (item) {
      this.$router.push('/common/section/more' + '/' + this.$route.params.tabBarId + '/' + item.id)
    },
    // 点击列表
    clcikList (item) {
      this.$router.push('/common/section/detail' + '/' + this.$route.params.tabBarId + '/' + item.tabBarId + '/' + item.id
      )
    },
    // 跳转页面
    navigateTo (path) {
      this.$router.push(path)
    },
  },
}
</script>
<style lang="less" scoped>
// banner
.banner {
  img {
    width: 100%;
    height: 300px;
  }
}

// 通知公告
.menu6_box2 {
  background: #f9f9f9;
  height: 465px;

  .box2_list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 430px;

    .box1_r {
      width: 375px;
      height: 350px;
      border: 1px solid #eee;
      background: #fff;

      .t_title {
        padding: 0 20px;
        height: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        span:nth-child(1) {
          font-size: 24px;
          color: #444;
          line-height: 54px;
          position: relative;

          &::after {
            content: "";
            position: absolute;
            width: 100%;
            height: 2px;
            background: #8d080e;
            bottom: 2px;
            left: 0;
          }
        }

        span:nth-child(2) {
          color: #666;
          cursor: pointer;
        }
      }

      .t_list {
        height: 280px;
        padding: 0 20px;
        overflow: hidden;

        .t_list_ul {
          width: 100%;
          height: 100%;
          padding-top: 10px;

          .t_list_li {
            height: 45px;
            padding-left: 20px;
            position: relative;
            border-bottom: 1px solid #eee;
            line-height: 45px;

            span {
              width: 100%;
              color: #333;
              display: block;
              cursor: pointer;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-size: 15px;

              &:hover {
                color: #8D080E;
              }

              &::after {
                content: "";
                position: absolute;
                width: 5px;
                height: 5px;
                background: #8d080e;
                border-radius: 50%;
                left: 0;
                top: 50%;
              }
            }
          }
        }
      }
    }
  }
}

li, ol, ul {
  list-style: none;
}

.time {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.content {
  width: 1200px;
  margin: 0 auto;
}
</style>
<style lang="less" scoped>
.swiper {
  width: 100%;
  height: 300px;

  .swiper_img {
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
    }
  }
}

.swiper-pagination {
  /* 未选中时的分页器子弹样式 */

  .swiper-pagination-bullet {
    background-color: #000 !important; /* 未选中时的背景色 */
    width: 8px;
    height: 8px;
    opacity: 0.3 !important;
    //transition: background-color 0.3s, transform 0.3s !important;
  }

  /* 选中时的分页器子弹样式 */

  .swiper-pagination-bullet.swiper-pagination-bullet-active {
    background-color: #8D080E !important; /* 选中时的背景色 */
    width: 15px !important; /* 选中时的宽度 */
    height: 8px;
    opacity: 1 !important;
    border-radius: 5px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Student/home.vue